import type { Rect } from './types.js';

export function bounds(r: Rect) {
    return { left: r.x - r.w / 2, right: r.x + r.w / 2, top: r.y - r.h / 2, bottom: r.y + r.h / 2 };
}

/** Even-odd point-in-polygon on a flat [x0, y0, x1, y1, ...] ring (an airport outline). */
export function insidePolygon(poly: readonly number[], px: number, py: number): boolean {
    let inside = false;
    for (let i = 0, j = poly.length - 2; i < poly.length; j = i, i += 2) {
        const xi = poly[i], yi = poly[i + 1], xj = poly[j], yj = poly[j + 1];
        if ((yi > py) !== (yj > py) && px < (xj - xi) * (py - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
}
